// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2PRZg","inputWrap":"Table_inputWrap__MGiqE","col":"Table_col__3yJB6","bmiTooltip":"Table_bmiTooltip__3JPkg"};